export default "__VITE_ASSET__a5597d5b__"